// @flow

export default localStorage
